import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordComponent } from './forgot-password.component';
import { SharedModule } from '@app/shared/shared.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    ForgotPasswordComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashFormsModule,
    RouterModule,
  ],
  exports: [
    ForgotPasswordComponent
  ]
})
export class ForgotPasswordModule { }
